export const searchRecordsByKeyword = (keyword: string, records: any[]): any[] => {
  const filtered: any[] = [];
  if (keyword) {
    for (const record of records) {
      for (const element of Object.values(record)) {
        if (element?.toString().toLowerCase().includes(keyword.toLowerCase().trim())) {
          filtered.push(record);
          break;
        }
      }
    }
    return filtered;
  }
  return records;
}

interface SortField {
  value: string;
  label: string;
}

export const getSortFields = (exampleObject: Record<string, any>): SortField[] => {

  const fieldList: SortField[] = [];

  const properties = Object.keys(exampleObject);

  const formatLabel = (camelCaseProperty: string): string => {
    const camelCase = camelCaseProperty.replace(/([a-z])([A-Z])/g, '$1 $2').split(" ")

    let flat = ""

    camelCase.forEach((word: string) => {
      flat = flat + word.charAt(0).toUpperCase() + word.slice(1) + " "
    })
    return flat;
  }

  properties.map(property => fieldList.push({value: property, label: formatLabel(property)}));

  return fieldList;
}

/**
 * Whether the search list shows real results: the fetch is done and, when there are
 * yards, the map has reported its bounds (the list waits for them to filter). The list's
 * skeleton and the crawler snapshot (prerenderReady) both use this, so a snapshot can't
 * miss the list, the market summary or its nearby-market links (#3142 review).
 */
export const isSearchListSettled = ({ hasFetchedSuppliers, loadingSuppliers, mapBoundsInitialized, yardCount }: {
  hasFetchedSuppliers: boolean;
  loadingSuppliers: boolean;
  mapBoundsInitialized: boolean;
  yardCount: number;
}): boolean => hasFetchedSuppliers && !loadingSuppliers && (mapBoundsInitialized || yardCount === 0);
